import * as Yup from 'yup';

export default [
  {
    name: 'clientCode',
    initialValue: '',
    validation: Yup.string().required('Required'),
    input: {
      label: 'Client Code',
      type: 'input',
    },
  },
  {
    name: 'username',
    initialValue: '',
    validation: Yup.string().required('Required'),
    input: {
      label: 'Username',
      type: 'input',
    },
  },
  {
    name: 'password',
    initialValue: '',
    validation: Yup.string().required('Required'),
    input: {
      label: 'Password',
      type: 'password',
    },
  },
];
